import { render, staticRenderFns } from "./myAccount.vue?vue&type=template&id=289f60a1"
import script from "./myAccount.vue?vue&type=script&lang=js"
export * from "./myAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports